'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



//////////////////
// WEBPACK FOOTER
// ./node_modules/ml-matrix/src/index.js
// module id = 8
// module chunks = 0